// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1522":"2e84d401626964bc","7734":"a349545879acac46"}[chunkId] + ".js";
};